/** The sign-in pages and the server's sign-in endpoints: never a place to return to. */
const LOOPING_PATHS = /^\/(?:sign-in|welcome|no-access|auth)(?:[/?#]|$)/i;

/**
 * Where the app may send someone after sign-in. Mirrors the server's `safeReturnTo`
 * (apps/server/src/auth/return-to.ts) exactly — a same-site path: starts with "/", not "//" or
 * "/\", at most 512 characters, no control characters — and anything else becomes "/".
 *
 * One client-only addition: the sign-in pages themselves ("/sign-in", "/welcome", "/no-access")
 * and the server's "/auth/…" endpoints also become "/", so a stale link can't loop.
 */
export function safeReturnTo(value: unknown): string {
  if (typeof value !== 'string' || value.length === 0 || value.length > 512) return '/';
  if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return '/';
  for (let i = 0; i < value.length; i++) {
    if (value.charCodeAt(i) < 0x20) return '/';
  }
  return LOOPING_PATHS.test(value) ? '/' : value;
}

/** The sign-in page, remembering where the person was going. */
export function signInPagePath(returnTo: string): string {
  return `/sign-in?returnTo=${encodeURIComponent(safeReturnTo(returnTo))}`;
}

/** The server's sign-in endpoint: a full-page navigation to Microsoft Entra ID and back. */
export function serverSignInPath(returnTo: string): string {
  return `/auth/sign-in?returnTo=${encodeURIComponent(safeReturnTo(returnTo))}`;
}
